module.exports = __webpack_public_path__ + "img/transparent_webstorm.5c39aa79.png";